// Legacy renderInput sites pass Autocomplete's `params.inputProps` as the Input root's `InputProps`.
// Its `ref` must only reach the <input> (it already does via `{...params}`); on the root it resolves
// Autocomplete's input ref to the wrapping <div> and MUI logs "Unable to find the input element".
export const autocompleteRootProps = ({ ref, ...rest }: Record<string, any>) => rest;
